import gql from 'graphql-tag';

export default gql`
fragment UserAllDataFragment on User {
    id
    ext_id
    last_login
    email
    name
    telephone
    created_at
    lyoness_card_number
    is_admin
    ip_address
    orders_count
    orders_value_sum
    first_order_date
    last_order_date
    granted_permissions
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/fragments/UserAllDataFragment.ts